import React, { useState } from 'react'
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material'
import logo from '../../assets/Project_Images/App_logo.png'
import email from '../../assets/Project_Images/Icons/email.png'
import { PersonOutline } from '@mui/icons-material'
import { Link, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom'
// import { ApiSendOtp } from '../../apiService/Core/Apicall'
import { ApiSendOtp } from '../../apiService/Core/Apicall.tsx'
import { useDispatch, useSelector } from 'react-redux'
import { hideLoading, showLoading } from '../../Redux/loadingSlice.tsx'
import Loading from '../Loader/Loading.tsx'
import { toast } from 'react-toastify'

interface FormValues {
    email: string;
}
const CreateShopper: React.FC = () => {
    const dispatch = useDispatch()
    const navigation = useNavigate()
    const location = useLocation();
    const loading = useSelector((state: any) => state.loader.isLoading);
    const isForgot = location.state?.isForgot;
    const [showerror, setshowerror] = useState<boolean>(false);

    const initialValues: FormValues = {
        email: '',
    }
    const keyup = (e: any) => {
        if (e.code === "Enter") {
            formik.handleSubmit();
        }
    };


    const onSubmit = async (values: FormValues) => {
        const Apidata = {
            emailId: values.email,
            requestType: isForgot ? "forgot_password":"new_shopper_registration"
        }
        try {
            const response: any = await ApiSendOtp(Apidata);
            if (response.status) {
                localStorage.setItem('auth', "otp");
                localStorage.setItem('emailId', values.email);

                navigation('/otp', isForgot && {state:{isForgot:true}})
            }

        }
        catch (error) {
            toast.error(error.message)
        }
    }
    const validationSchema = Yup.object({
        email: Yup.string().email('Invalid email format').required("Enter your email"),

    });
    const formik = useFormik<FormValues>({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: false,
    })
    return (
        <Box className='p-50-120 d-flex flex-column' height={{ xs: "80vh", sm: '100vh' }}>
            <Box component='img' className='col-md-4 col-6 mb-md-5 mb-3' src={logo} alt="" />
            <Box className='flex-grow-1 mt-5' position='relative'>
                <Typography className='text-main fs-3 fw-bold'>{isForgot ? 'Reset Password' :'Become a Shopper'}</Typography>
                <Typography className='fs-18 '>Let’s verify your email to {isForgot ? 'reset your password':'get you started'}.</Typography>
                <Box className='mt-5 mt-md-0'>
                    <form onSubmit={formik.handleSubmit}>
                        <FormControl className='col-12'>
                            <TextField
                                label={
                                    <span>
                                        Email ID{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                slotProps={{
                                    input: {
                                        startAdornment: <PersonOutline className='fs-2 text-main' />
                                    }
                                }}
                                InputLabelProps={{
                                    shrink: false,

                                }}
                                {...formik.getFieldProps("email")}
                            ></TextField>
                            {showerror && formik.errors.email ? (
                                <Typography className="error ">
                                    {formik.errors.email}
                                </Typography>
                            ) : null}
                        </FormControl>

                        <Typography className='d-block mt-4'>You'll receive an OTP to verify your email</Typography>
                        <Button type='submit' onClick={() => setshowerror(true)} fullWidth className='button-primary mt-5'>Get OTP</Button>
                    </form>
                </Box>
            </Box>
            {loading && <Loading />}
        </Box>
    )
}

export default CreateShopper
